export default __webpack_public_path__ + "static/media/1995.1f0e7764.png";